import { render } from "./EditDiscounts.vue?vue&type=template&id=a63805e6"
import script from "./EditDiscounts.vue?vue&type=script&lang=js"
export * from "./EditDiscounts.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__